module.exports = __webpack_public_path__ + "img/dgtek-logo.7e6edc83.svg";